import loader from "../moduleLoader.js";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";

class Grid {
  constructor(container) {
    this.container = container;
  }
  init() {
    imagesLoaded(this.container, () => {
      var msnry = new Masonry(this.container, {
        itemSelector: ".grid__item",
        // fitWidth: true,
       gutter:30,
        percentPosition: true,
        columnWidth:'.grid__item'
      });
    });
  }
}

loader.add("Grid", Grid);
export default Grid;
